module.exports = __webpack_public_path__ + "static/img/technology.d8d3652.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/technology.gif
// module id = TVBj
// module chunks = 0